import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';
import { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Button from '@mui/material/Button';
import TranslationText from '@Components/Utilities/TranslationText';

const AddressValidationModal = (props) => {

    const suggestionModal = props.recommendedAddress.AddressError ? false : true;
    const modalHeader = suggestionModal ? translator.translate('sandhills.wereunabletoverifyaddressbutfoundmatch') : translator.translate('sandhills.wereunabletoverifyaddress');
    const addressData = { "formData": props.formData, "recommendedAddress": props.recommendedAddress }
    const [selectedAddress, setSelectedAddress] = useState(suggestionModal ? addressData.recommendedAddress : addressData.formData);
    const [showEscError, setShowEscError] = useState(false);

    const updateAddress = (e) => {
        e.preventDefault();
        let validated = selectedAddress == addressData.recommendedAddress;
        props.closeModalAndSubmit?.(selectedAddress, validated);
    };

    useEffect(() => {
        let suggestionRadio = document.getElementsByName('address-suggestion')[0];
        let enteredRadio = document.getElementsByName('address-entered')[0];

        if (suggestionRadio) {
            suggestionRadio.focus();
        } else {
            enteredRadio.focus();
        }
    }, []);

    const addressMarkup = (address) => {
        return (
            <span>
                {address.Address1 + ' ' + address.Address2}<br />
                {address.City + ', ' + address.State + ' ' + address.PostalCode}
            </span>
        );
    };

    const renderRadio = (address, isSuggestion) => {
        return (
            <>
                <strong>{isSuggestion ? translator.translate('sandhills.recommended') : translator.translate('sandhills.youentered')}:</strong>
                <FormControlLabel className={'address-modal__address-container' + (selectedAddress == address ? ' address-modal__address-container_active' : '')} value={isSuggestion ? 'recommendedAddress' : 'formData'} name={isSuggestion ? 'address-suggestion' : 'address-entered'} control={<Radio />} label={addressMarkup(address)} />
            </>
        );
    };

    return (
        <>
            <Modal containerClassName='address-modal' onEscapeKeyClose={() => setShowEscError(true)}>
                <Modal.Header>
                    <Modal.Title>{modalHeader}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p id='description-label' className='hidden'>Validate address</p>
                    {!suggestionModal && <p className='address-modal__error-message'>{props.recommendedAddress.AddressError}</p>}
                    <FormControl style={{ width: '100%' }}>
                        <RadioGroup defaultValue={suggestionModal ? 'recommendedAddress' : 'formData'} onChange={(e) => setSelectedAddress(addressData[e.target.value])}>
                            {renderRadio(props.formData, false)}
                            {suggestionModal && renderRadio(props.recommendedAddress, true)}
                        </RadioGroup>
                        {!suggestionModal &&
                            <div style={{ marginBottom: '10px' }}>
                                <TranslationText tKey='Sandhills.PleaseSelectOptionToContinue' />
                            </div>
                        }
                        <div className='address-modal__buttons'>
                            <Button className='address-modal__button template-branded-button' variant='contained' onClick={(e) => updateAddress(e)}>{translator.translate('sandhills.usethisaddress')}</Button>
                            {!suggestionModal &&
                                <Button className='address-modal__button template-branded-button' variant='contained' onClick={() => props.toggleModal?.()}>{translator.translate('sandhills.editthisaddress')}</Button>}
                        </div>
                    </FormControl>
                    {showEscError &&
                        <div style={{ textAlign: 'center', color: '#b12c1b' }}>
                            <TranslationText tKey='sandhills.youmustselectanoption' />
                        </div>
                    }
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddressValidationModal;